(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("iT718", function(module, exports) {
var $dc02ce8e00353750$var$toggleBtn = document.querySelectorAll(".f-inquiry__accessories-btn");
$dc02ce8e00353750$var$toggleBtn.forEach(function(btn) {
    btn.addEventListener("click", function() {
        var _a;
        btn.classList.toggle("--open");
        (_a = btn.closest(".f-inquiry__accessories")) === null || _a === void 0 || _a.classList.toggle("--open");
    });
});
// Modal source tracking
var $dc02ce8e00353750$var$modalSource = null;
document.addEventListener("click", function(event) {
    var target = event.target;
    var button = target.closest("[data-modal-source]");
    if (button) {
        var source = button.getAttribute("data-modal-source");
        if (source) {
            $dc02ce8e00353750$var$modalSource = source;
            var hiddenInput = document.getElementById("vehicle_inquiry_modal_source");
            if (hiddenInput) hiddenInput.value = source;
        }
    }
});
document.addEventListener("click", function(event) {
    var target = event.target;
    var modalButton = target.closest("[data-modal-target]");
    if (modalButton && $dc02ce8e00353750$var$modalSource) {
        var hiddenInput = document.getElementById("vehicle_inquiry_modal_source");
        if (hiddenInput && $dc02ce8e00353750$var$modalSource) hiddenInput.value = $dc02ce8e00353750$var$modalSource;
    }
});

});

})();
//# sourceMappingURL=inquiry-form.dd44e7a1.js.map
